import { gql } from '@apollo/client'

const PATCH_MEMBER = gql`
  mutation createMember($member: MemberInput!) {
    createMember(member: $member) {
      message
      statusCode
      code
      error
    }
  }
`

export default PATCH_MEMBER
